// Function to check if an element exists
function elementExists(selector) {
  return document.querySelector(selector) !== null;
}
// Hover Listeners for the Header menu Dropdowns
function addHoverListeners(selector) {
  document.querySelectorAll(selector).forEach((element) => {
    element.addEventListener("mouseover", () => {
      element.setAttribute("open", "open");
    });

    element.addEventListener("mouseout", () => {
      element.removeAttribute("open");
    });
  });
}

document.addEventListener("DOMContentLoaded", (e) => {
  console.log(" /\\_/\\\n( o.o )\n > ^ <\n / | \\\n   |");
  console.log(
    "%cCustom JS is ready",
    "background: linear-gradient(to right, #000000, #F05623); color: #FFFFFF; font-weight: bold; font-size: 50px;"
  );

  //console.log(e);

  if (
    elementExists('details[id*="HeaderSubMenu"]') &&
    elementExists('details[id*="HeaderMenu"]')
  ) {
    addHoverListeners('details[id*="HeaderSubMenu"]');
    addHoverListeners('details[id*="HeaderMenu"]');
  }

  // Initialize bannerSlider if #banner-slider element exists
  if (elementExists("#banner-slider")) {
    var bannerSlider = new Splide("#banner-slider", {
      // type: "fade",
      // heightRatio: 0.5,
      pagination: true,
      arrows: false,
      type: "loop",
      // autoplay: true,
      // interval: 5000, // How long to display each slide
      pauseOnHover: true,
      pauseOnFocus: false, // must be false
      resetProgress: false,
    });
    bannerSlider.mount();
  }
  // Initialize homeLogoSplide if .logo-slider-inner element exists
  if (elementExists(".logo-slider-inner")) {
    var homeLogoSplide = new Splide(".logo-slider-inner", {
      type: "slide",
      drag: "free",
      snap: true,
      perPage: 5,
      rewind: true,
      gap: "24px",
      breakpoints: {
        768: {
          perPage: 4,
        },
        480: {
          perPage: 3,
        },
      },
    });
    homeLogoSplide.mount();
  }

  if (elementExists("[data-tab-title]") && elementExists("[data-coll-title]")) {
    var tabs = Array.from(document.querySelectorAll("[data-tab-title]"));
    var contents = Array.from(document.querySelectorAll("[data-coll-title]"));

    for (var i = 0; i < tabs.length; i++) {
      tabs[i].addEventListener("click", (e) => {
        var tabTitle = e.target.dataset.tabTitle;
        tabs.forEach((i) => i.classList.remove("active-coll"));
        e.target.classList.add("active-coll");
        contents.forEach((i) => {
          i.style.display = "none";
        });
        document.querySelector(
          '[data-coll-title="' + tabTitle + '"]'
        ).style.display = "";
      });
    }
  }

  //Video Control in Workshop
  // Click event for .workshop-3-video .about-video

  if (elementExists(".workshop-3-video")) {
    var workshop3 = document.querySelector(".workshop-3-video");
    document
      .querySelectorAll(".workshop-3-video .about-video")
      .forEach(function (video) {
        video.addEventListener("click", function () {
          if (video.currentTime > 0 && !video.paused) {
            video.pause();
          } else {
            video.play();
          }
        });
      });

    // Click event for .workshop-3-video .play-btn
    document
      .querySelectorAll(".workshop-3-video .play-btn")
      .forEach(function (playBtn) {
        playBtn.addEventListener("click", function () {
          playBtn.style.display = "none";

          document
            .querySelectorAll(".workshop-3-video .about-video")
            .forEach(function (video) {
              video.load();
              video.play();
              video.onended = function () {
                video.load();
                playBtn.style.display = "block";
              };
            });
        });
      });
  }

  if (
    elementExists("[data-similar-products]") &&
    elementExists(".recommendations")
  ) {
    var appender = document.querySelector("[data-similar-products]");
    var section = document.querySelector(".recommendations");
    var id = section.getAttribute("id");
    var sectionId = id.split("shopify-section-")[1];
    var productId = document.querySelector(".product-tabs-main-wrap").dataset
      .productId;
    var LIMIT = 4;
    var params = new URLSearchParams({
      section_id: sectionId,
      product_id: productId,
      limit: LIMIT,
    });
    const recommendationUrl = `/recommendations/products?${params.toString()}`;

    fetch(recommendationUrl)
      .then((response) => response.text())
      .then((text) => {
        appender.innerHTML = text;
      });
  }
  if (elementExists("#SubCategory")) {
    document.getElementById("SubCategory").addEventListener("change", (e) => {
      //console.log(e);
      window.location.href = e.target.value;
    });
  }
  if (window.location.href.includes("search")) {
    var searches = window.location.search;
    if (searches === "?q=" || searches.trim() === "") {
      document
        .querySelector(".template-search__header")
        .classList.remove("visually-hidden");
    } else {
      document.querySelector(".template-search__header").remove();
    }
  }
  if (
      elementExists("#create_customer .accept-agreement input") &&
    elementExists("#create_customer button")
  ) {
    var button = document.querySelector("#create_customer button");
    var checker = document.querySelector(
      "#create_customer .accept-agreement input"
    );
    checker.addEventListener("change", (e) => {
      if (e.target.checked) {
        button.disabled = false;
      } else {
        button.disabled = true;
      }
    });
  }

  if(window.location.href.includes('policies')){
    document.body.classList.add('template-policy');
  }
});
